// extracted by mini-css-extract-plugin
module.exports = {"handle":"ChatResizeHandle_handle__YDyDZ","grip":"ChatResizeHandle_grip__KkWkp"};